export const sanitizeInternationalPhone = (phone = '') => String(phone).replace(/[^\d+]/g, '');

export const buildDynamicWhatsappMessage = ({ title = '', customMessage = '' }) => {
  const cleanTitle = String(title || '').trim();
  const defaultMessage = `Hola, vi tu anuncio en Ágora Web y me interesa ${cleanTitle || 'tu propuesta'}.`;

  if (!customMessage) return defaultMessage;

  if (customMessage.includes('{{title}}')) {
    return customMessage.replaceAll('{{title}}', cleanTitle || 'tu propuesta');
  }

  return customMessage;
};

export const buildWhatsappUrl = ({ phone, title, customMessage }) => {
  const normalizedPhone = sanitizeInternationalPhone(phone);
  if (!normalizedPhone) return null;

  const text = encodeURIComponent(
    buildDynamicWhatsappMessage({ title, customMessage })
  );

  return `https://api.whatsapp.com/send?phone=${normalizedPhone}&text=${text}`;
};
